import { API } from '@config';

export const getMilestoneData = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let data;

  try {
    const response = await fetch(`${API}/api/milestones?sort[0]=Date:desc&populate=*`, options);
    data = await response.json();

    return data;
  } catch (err) {
    console.error(err);
  }

  return data;
};
